// Copyright 2025, University of Maryland, All Rights Reserved
import { CostsComponent } from '@umd-dit-ai-workspace/costs-component';
import '@umd-dit-ai-workspace/costs-component/dist/index.css';
import { useAuth } from '@umd-dit-ai-workspace/workspaces-component';
import { apiClient } from '@/api/api-client';

export default function Costs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  console.log('[Costs] Component rendering with:', {
    selectedOrganizationId,
    selectedWorkspaceId,
    isAdmin
  });

  // Don't render the costs component until we have a workspace selected
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-gray-600">Please select a workspace to view costs.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-4">
      {/* React component using shared API client */}
      <CostsComponent
        app_id="legislative-review"
        api_instance={apiClient.getAxiosInstance()}
        organization_id={selectedOrganizationId}
        workspace_id={selectedWorkspaceId}
        default_cost_view="workspace"
        is_admin={isAdmin}
      />
    </div>
  );
}